require('../../modules/esnext.reflect.has-metadata');
var path = require('../../internals/path');

module.exports = path.Reflect.hasMetadata;
